import React from 'react';

function Disciplines() {
	return (
		<section id="disciplines">
			<h2>Additional Disciplines</h2>
			<ul id="disciplines_list">
				<li>
					<h3>Site Speed Optimisation</h3>
					<span className="notes">Improving key metrics to improve accessibility and SEO rankings</span>
				</li>
				<li>
					<h3>Competitor Monitoring</h3>
					<span className="notes">Keeping an eye on the competition using a variety of tools</span>
				</li>
				<li>
					<h3>PPC Message Matching</h3>
					<span className="notes">Ensuring consistency for users, aiding PPC Performance</span>
				</li>
				<li>
					<h3>Personalisation</h3>
					<span className="notes">Providing personalised offers and messaging to individual users</span>
				</li>
				<li>
					<h3>Google Analytics</h3>
					<span className="notes">Google Analytics Individual Qualification (GAIQ)</span>
				</li>
				<li>
					<h3>Mentoring/Training</h3>
					<span className="notes">Mentoring new starters and improving their skills in JavaScript, CSS and CRO is something that I enjoy. Whilst at iProspect I have been responsible for teaching several junior team members, as well as aiding more advanced team members where necessary.</span>
				</li>
			</ul>
		</section>
	);
}

export default Disciplines;
